import { ApiConfig } from '../models/ApiConfig';
import devApiConfig from './data/dev_api_config.json';
// import qaApiConfig from './data/qa_api_config.json';
// import prodApiConfig from './data/prod_api_config.json';

// Auth url is not longer in use
const Config: ApiConfig = JSON.parse(JSON.stringify(devApiConfig));

export default Config;
